import { useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { useCustomer } from '@/api/customers/use-customer';
import { Text } from '@/ui';

export enum StepType {
  COMPLETED = 'Completed',
  NEXT = 'Next',
  UPCOMING = 'Upcoming',
}

export interface TripStep {
  type: StepType;
  title: string;
  body?: string;
  footer?: React.ReactNode;
}

interface TripTimelineProps {
  steps: TripStep[];
  children?: React.ReactNode;
}

export default function TripTimeline({ steps, children }: TripTimelineProps) {
  const { styles, theme } = useStyles(stylesheet);
  const local = useLocalSearchParams<{ id: string }>();

  const { data: customer } = useCustomer();

  const stepColor = (type: StepType) => {
    switch (type) {
      case StepType.COMPLETED:
        return theme.colors.tripStep.completed.color;
      case StepType.NEXT:
        return theme.colors.tripStep.next.color;
      case StepType.UPCOMING:
        return theme.colors.tripStep.upcoming.color;
    }
  };

  return (
    <View style={styles.container}>
      <View style={{ gap: 24 }}>
        {steps.map((step, index) => {
          return (
            <View key={index} style={{ flexDirection: 'row', gap: 8 }}>
              <View
                style={{
                  backgroundColor: stepColor(step.type),
                  width: 8,
                  height: 8,
                  borderRadius: 8,
                  marginTop: 4,
                }}
              />

              <View style={{ flex: 1 }}>
                <Text
                  type="caption1"
                  style={{
                    color: stepColor(step.type),
                  }}
                >
                  {step.type}
                </Text>

                <Text type="bodyRegular">{step.title}</Text>

                {step.body ? (
                  <Text
                    type="bodyRegular"
                    style={{
                      color: theme.colors.text.secondary,
                    }}
                  >
                    {step.body}
                  </Text>
                ) : null}

                {step.footer ? step.footer : null}
              </View>
            </View>
          );
        })}
      </View>

      {children}
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    backgroundColor: theme.colors.background_2,
  },
}));
